export default function formatMessageContentHtml ({text}) {
    return {
        text
    }
}
